var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { z } from "zod";
import { getClassification } from "@alveusgg/data/build/ambassadors/classification";
import allAmbassadors, { ambassadorSchema, } from "@alveusgg/data/build/ambassadors/core";
import { isActiveAmbassadorEntry } from "@alveusgg/data/build/ambassadors/filters";
import { ambassadorImageSchema, getAmbassadorImages, } from "@alveusgg/data/build/ambassadors/images";
import { getSpecies, speciesSchema, } from "@alveusgg/data/build/ambassadors/species";
import enclosures from "@alveusgg/data/build/enclosures";
import { getIUCNStatus } from "@alveusgg/data/build/iucn";
import { getToday } from "../utils/dateManager";
import { typeSafeObjectEntries, typeSafeObjectFromEntries, } from "../utils/helpers";
import winstonImage from "../assets/winston.png";
// These schema should match the type exposed by the API
var apiAmbassadorSchema = ambassadorSchema.extend({
    image: ambassadorImageSchema.extend({
        src: z.string().url(),
    }),
    species: speciesSchema.extend({
        key: z.string(),
        iucn: speciesSchema.shape.iucn.and(z.object({
            title: z.string(),
        })),
        class: z.object({
            key: z.string(),
            title: z.string(),
        }),
    }),
    enclosure: z.object({
        key: z.string(),
        title: z.string(),
    }),
});
// Use transform here so we parse each ambassador individually
var apiSchema = z.object({
    v4: z
        .record(z.string(), 
    // Use nullable here as the fallback for when we fail to parse an ambassador
    apiAmbassadorSchema.nullable().catch(function (ctx) {
        console.error("Failed to parse ambassador", ctx.value, z.prettifyError(ctx.error));
        return null;
    }))
        .transform(function (val) {
        // Filter out any null values that failed to parse
        return typeSafeObjectFromEntries(Object.entries(val).filter(function (entry) { return !!entry[1]; }));
    })
        // Ensure we didn't fail to parse all ambassadors
        .refine(function (val) { return Object.keys(val).length > 0; }, {
        message: "No ambassadors found",
    }),
});
var apiBaseUrl = (_a = process.env.REACT_APP_API_BASE_URL) === null || _a === void 0 ? void 0 : _a.replace(/\/+$/, "");
if (!apiBaseUrl)
    throw new Error("REACT_APP_API_BASE_URL environment variable is not set");
var fetchAmbassadors = function () { return __awaiter(void 0, void 0, Promise, function () {
    var response, _a, _b, _c, data;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, fetch("".concat(apiBaseUrl, "/api/stream/ambassadors"))];
            case 1:
                response = _d.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                _a = Error.bind;
                _c = (_b = "Failed to fetch ambassadors: ".concat(response.status, " ").concat(response.statusText, " ")).concat;
                return [4 /*yield*/, response.text()];
            case 2: throw new (_a.apply(Error, [void 0, _c.apply(_b, [_d.sent()])]))();
            case 3: return [4 /*yield*/, response.json()];
            case 4:
                data = _d.sent();
                return [2 /*return*/, apiSchema.parse(data).v4];
        }
    });
}); };
var fallbackAmbassadors = typeSafeObjectFromEntries(typeSafeObjectEntries(allAmbassadors)
    .filter(isActiveAmbassadorEntry)
    .map(function (_a) {
    var key = _a[0], val = _a[1];
    var image = getAmbassadorImages(key)[0];
    var species = getSpecies(val.species);
    return [
        key,
        __assign(__assign({}, val), { image: image, species: __assign(__assign({}, species), { key: val.species, iucn: __assign(__assign({}, species.iucn), { title: getIUCNStatus(species.iucn.status) }), class: {
                    key: species.class,
                    title: getClassification(species.class),
                } }), enclosure: {
                key: val.enclosure,
                title: enclosures[val.enclosure].name,
            } }),
    ];
}));
// Use a context to fetch the ambassadors from the API
var Context = createContext(null);
export var AmbassadorsProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), ambassadors = _b[0], setAmbassadors = _b[1];
    // On mount, attempt to fetch the ambassadors from the API
    // If we can't fetch the ambassadors, use the data from the data package
    useEffect(function () {
        fetchAmbassadors()
            .catch(function (err) {
            console.error(err);
            return fallbackAmbassadors;
        })
            .then(setAmbassadors);
    }, []);
    // Refresh the current ambassadors after a !refresh command
    var refresh = useCallback(function () {
        fetchAmbassadors()
            .then(setAmbassadors)
            .catch(function (err) { return console.error(err); });
    }, []);
    // Every 2 hours, attempt to fetch the ambassadors from the API
    // If we can't fetch the ambassadors, we'll just use the existing data
    useEffect(function () {
        var interval = setInterval(function () {
            fetchAmbassadors()
                .then(setAmbassadors)
                .catch(function (err) { return console.error(err); });
        }, 2 * 60 * 60 * 1000);
        return function () { return clearInterval(interval); };
    }, []);
    return (_jsx(Context.Provider, { value: { ambassadors: ambassadors, refresh: refresh }, children: children }));
};
var winston = {
    name: "Winston",
    alternate: [],
    commands: ["winston"],
    species: {
        key: "polarBear",
        name: "Polar Bear",
        scientificName: "Twitchus memeticus",
        iucn: {
            id: null,
            assessment: null,
            title: getIUCNStatus("NE"),
            status: "NE",
        },
        native: "Twitch chat (including the Animals, Aquariums, & Zoos category), miscellaneous emote services",
        lifespan: {
            wild: "Unknown",
            captivity: "Unknown",
        },
        birth: "live",
        class: {
            key: "mammalia",
            title: getClassification("mammalia"),
        },
    },
    sex: "Male",
    birth: "2020-04-01",
    arrival: "2022-12-01",
    retired: null,
    enclosure: {
        key: "ice",
        title: "Ice Pool",
    },
    story: "Winston was rescued by the Ontario Zoo in Canada after it was noticed that he was watching streams too often and not touching grass. Originally on loan to Alveus for two years, he is now a permanent resident of Texas.",
    mission: "He is an ambassador for stream-life balance and encouraging all chatters to step away from their devices more often.",
    clips: [],
    homepage: null,
    plush: null,
    image: {
        src: winstonImage,
        alt: "Winston the polar bear",
        position: "50% 25%",
    },
};
var isWinstonDate = function (date) { return date === "04-01"; };
export var useAmbassadors = function () {
    var context = useContext(Context);
    // Setup a timer to store the current month and day
    var _a = useState(""), date = _a[0], setDate = _a[1];
    useEffect(function () {
        var updateDate = function () { return setDate(getToday().toFormat("MM-dd")); };
        updateDate();
        var interval = setInterval(updateDate, 60 * 1000);
        return function () { return clearInterval(interval); };
    }, []);
    // Return the ambassadors, with Winston added to the start if it's April 1st
    return useMemo(function () {
        return (context === null || context === void 0 ? void 0 : context.ambassadors)
            ? __assign(__assign({}, context === null || context === void 0 ? void 0 : context.ambassadors), (isWinstonDate(date) ? { winston: winston } : {})) : null;
    }, [context === null || context === void 0 ? void 0 : context.ambassadors, date]);
};
export var useAmbassador = function (key) {
    var ambassadors = useAmbassadors();
    return ambassadors === null || ambassadors === void 0 ? void 0 : ambassadors[key];
};
export var useAmbassadorsRefresh = function () {
    var context = useContext(Context);
    return context === null || context === void 0 ? void 0 : context.refresh;
};
